import React from 'react';
import '../styles/Projects.css';
import appiloIcon from '../assets/images/appilo-icon.svg';

interface ProjectProps {
  title: string;
  description: string;
  technologies: string[];
  imageUrl?: string;
  githubUrl?: string;
  liveUrl?: string;
  websiteUrl?: string;
}

const Project: React.FC<ProjectProps> = ({ 
  title, 
  description, 
  technologies, 
  imageUrl, 
  githubUrl, 
  liveUrl,
  websiteUrl
}) => {
  return (
    <div className="project-card">
      <div className="project-image">
        {imageUrl ? (
          <img src={imageUrl} alt={title} />
        ) : (
          <div className="image-placeholder">
            <span className="code-icon">{'</>'}</span>
          </div>
        )}
      </div>
      <div className="project-info">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="technologies">
          {technologies.map((tech, index) => (
            <span key={index} className="tech-tag">{tech}</span>
          ))}
        </div>
        <div className="project-links">
          {githubUrl && (
            <a href={githubUrl} target="_blank" rel="noopener noreferrer" className="project-link github">
              GitHub
            </a>
          )}
          {liveUrl && (
            <a href={liveUrl} target="_blank" rel="noopener noreferrer" className="project-link live">
              Live Demo
            </a>
          )}
          {websiteUrl && (
            <a href={websiteUrl} target="_blank" rel="noopener noreferrer" className="project-link live">
              Website
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

const Projects: React.FC = () => {
  const projectsData: ProjectProps[] = [
    {
      title: "Appilo",
      description: "Appilo is a desktop utility tool, designed for macOS, to help users manage their installed software. It provides a centralized dashboard for monitoring, editing and removing applications.",
      technologies: ["TypeScript", "Node.js", "Electron", "React"],
      websiteUrl: "https://appilo.app",
      imageUrl: appiloIcon
    },
  ];

  return (
    <section className="projects-section" id="projects">
      <div className="projects-container">
        <h2 className="section-title">My Projects</h2>
        <p className="section-description">
          Some of the security and development projects I've worked on recently!
        </p>
        
        <div className="projects-grid">
          {projectsData.map((project, index) => (
            <Project key={index} {...project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects; 